import React from 'react';

const Logo = ({ className = "", variant = "horizontal" }) => {
  const src = variant === "compact"
    ? "/logos/apelgp-logo-compact.svg"
    : "/logos/apelgp-logo-horizontal.svg";

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={src}
        alt="APELGP - Culture, Loisirs, Lien Social"
        className={variant === "compact" ? "h-14 w-auto" : "h-12 w-auto md:h-14"}
        loading="eager"
      />
    </div>
  );
};

export default Logo;
